import { render, staticRenderFns } from "./BusAssignments.vue?vue&type=template&id=8eab49d4&"
import script from "./BusAssignments.vue?vue&type=script&lang=js&"
export * from "./BusAssignments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports